var YepNopeMessagePopup = require("app/AppLayout/YepNopeMessagePopup"),
    frameThrottle       = require("enyo-perf/utils").frameThrottle,
    get                 = require("object-path").get,
    icons               = require("app/theme/icons"),
    kind                = require("enyo/kind");

require("./AdsRequiredView.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");
require("app/theme/styles/popups/ScrollerPopup--borderless.less");

module.exports = kind(/** @lends  app.MediaPlayer.AdsRequiredView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.AdsRequiredView",

    /**
     * @private
     */
    kind: YepNopeMessagePopup,

    /**
     * @private
     */
    layoutOptions: {
        /**
         * Center in contentRegion when maximized, center on screen otherwise.
         *
         * @returns {string} The alignment
         */
        alignment: function() {
            return this.container.controller.get("displayMode") === "maximized"
                ? "contentRegion"
                : "fullLayout";
        },

        /**
         * Expand layout if player is maximized.
         *
         * @returns {boolean} Whether to expand the popup
         */
        expand: function() {
            return this.container.controller.get("displayMode") === "maximized";
        },

        /**
         * Overlap safe area if player is maximized.
         *
         * @returns {boolean} Whether to overlap the safe area
         */
        overlapSafeArea: function() {
            return this.container.controller.get("displayMode") === "maximized";
        },

        /**
         * Clear floating header if player is not maximized.
         *
         * @returns {boolean} Whether to clear floating header
         */
        clearFloatingHeader: false
    },

    /**
     * @private
     */
    classes: "app-media-player-ads-required-view",

    /**
     * @private
     */
    scrimOptions: {
        classes: "app-media-player-ads-required-view__scrim"
    },

    /**
     * @private
     */
    showCloseButton: false,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @private
     */
    state: null,

    /**
     * @private
     */
    handlers: {
        onMessageYepButtonTap:  "onMessageYepButtonTap",
        onMessageNopeButtonTap: "onMessageNopeButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.yepButton.set("icon", icons["app.MediaPlayer.AdsRequiredView.yepButton"]);
            this.$.message.$.nopeButton.set("icon", icons["app.MediaPlayer.AdsRequiredView.nopeButton"]);
        };
    }),

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("controller.displayMode", this.resize);
            this.update();
        };
    }),

    /**
     * @private
     */
    reflow: kind.inherit(function(sup) {
        return function() {
            if (this.controller.get("displayMode") === "maximized") {
                // Expanded popup is borderless
                this.set("theme", "borderless");
            }
            else {
                // Unexpanded popup is bordered
                this.set("theme", "bordered");
            }
            sup.apply(this, arguments);
        };
    }),

    /**
     * @private
     */
    afterMount: function() {
        if (this.controller.get("displayMode") === "maximized") {
            this.requestShow(true, true);
        }
        else {
            this.requestShow(true, false);
        }
    },

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.MediaPlayer.AdsRequiredError.title"));
        $message.$.body.set("content", i18nService.getString("app.MediaPlayer.AdsRequiredError.body", {
            mediaType: get(this, "state.params.mediaType", null) || ""
        }));
        $message.$.yepButton.set("caption", i18nService.getString("app.MediaPlayer.AdsRequiredError.ReloadButton.caption"));
        $message.$.yepButton.set("tooltip", i18nService.getString("app.MediaPlayer.AdsRequiredError.ReloadButton.tooltip"));
        $message.$.nopeButton.set("caption", i18nService.getString("app.MediaPlayer.AdsRequiredError.CancelButton.caption"));
        $message.$.nopeButton.set("tooltip", i18nService.getString("app.MediaPlayer.AdsRequiredError.CancelButton.tooltip"));
    },

    /**
     * Go to the unsuspend page
     *
     * @private
     */
    onMessageYepButtonTap: function() {
        this.app.$.router.reload();
    },

    /**
     * Deactivate the player. If the player is the maximized, we'll also
     * navigate back to the previous route.
     *
     * @private
     */
    onMessageNopeButtonTap: function() {
        var maximized,
            router;

        // We actually need to cache these values, because deactivating the
        // player will remove access to them, yet we do want to deactivate the
        // player before triggering a new route.
        maximized = this.controller.get("displayMode") === "maximized";
        router    = this.app.$.router;

        // Close the MediaPlayer first, because it doesn't necessarily get
        // deactivated by navigating back to the previous route.
        this.app.$.mediaPlayerManager.deactivateMediaPlayer();

        // If we were not maximized, closing the player was enough. If were
        // maximized, we also need to navigate back to the previous route.
        maximized && router.back(true);
    }

});
